import $ from 'jquery'
import _ from 'underscore'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-search')
    .each(function(i, el) {
      new Search(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

class Search {
  constructor(el) {
    const self = this
    self.uid = _.uniqueId('scuba-')
    self.$el = $(el)

    self.$type = self.$el.find('.js-search__input__type').first()
    self.$typeText = self.$el.find('.js-search__input__type-text').first()

    self.$type
      .on('change', e => {
        self.$typeText.text(
          self.$type.find(`[value="${self.$type.val()}"]`).text()
        )
      })
      .trigger('change')
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Search.js